import * as Models from '../.';
export interface IDocumentUploadModel {
    documentType?: Models.DocumentManagement.SolarDocumentType.ISolarDocumentType;
    file: File;
    fileExtension: string;
    userInputFileName: string; // file.name is immutable, need this to allow edit
    key: string;
    submissionUser?: string;
}

export class CustomerDocumentUploadModel implements IDocumentUploadModel {
    documentType: Models.DocumentManagement.SolarDocumentType.ISolarDocumentType;
    file: File;
    fileExtension: string;
    userInputFileName: string;
    key: string;
 
    constructor(documentType?: Models.DocumentManagement.SolarDocumentType.ISolarDocumentType) {
        if (documentType) {
            this.documentType = documentType;
        }
    }
}

export class IssueDocumentUploadModel implements IDocumentUploadModel {
    file: File;
    fileExtension: string;
    userInputFileName: string;
    key: string;
    submissionUser: string;
}
